import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function createDateRangeValidator() {
  return (form: AbstractControl): ValidationErrors | null => {
    // Use startTimeDate and endTimeDate which are proper Date objects
    const startTimeDate = form.get("startTimeDate")?.value;
    const endTimeDate = form.get("endTimeDate")?.value;

    const start: Date | null = startTimeDate ? new Date(startTimeDate) : null;
    const end: Date | null = endTimeDate ? new Date(endTimeDate) : null;

    if (start && end && !isNaN(start.getTime()) && !isNaN(end.getTime())) {
      const isRangeValid = (end.getTime() - start.getTime() > 0);
      if(!isRangeValid){
        form.get("endTime")?.setErrors({ dateRange: true });
      }
      return isRangeValid ? null : {dateRange: true};
    }

    return null;
  }
}
export function validateSum() {
  return (form: AbstractControl): ValidationErrors | null => {
    const paymentType: number = form.get("paymentType")?.value;
    if(!paymentType){
      return null;
    }
    if(paymentType === 1){
      const cash: number = form.get('cash')?.value ? +form.get('cash')?.value : 0;
      const price: number = form.get('price')?.value ? +form.get('price')?.value : 0;
      if (cash && price) {
        if(cash < 1 && price > 0){
          return {totalPrice: true};
        }
        const isRangeValid = (cash <= price);
        return isRangeValid ? null : {totalPrice: true};
      }
    }

    if(paymentType === 2){
      const card: number = form.get('card')?.value ? +form.get('card')?.value : 0;
      const price: number = form.get('price')?.value ? +form.get('price')?.value : 0;
      if (card && price) {
        if(card < 1 && price > 0){
          return {totalPrice: true};
        }
        const isRangeValid = (card <= price);
        return isRangeValid ? null : {totalPrice: true};
      }
    }

    if(paymentType === 3){
      const cash: number = form.get('cash')?.value ? +form.get('cash')?.value : 0;
      const card: number = form.get('card')?.value ? +form.get('card')?.value : 0;
      const price: number = form.get('price')?.value ? +form.get('price')?.value : 0;
      if((cash + card) === 0){
        return {totalPrice: true};
      }
      if ((cash || card) && price) {
        if((cash + card) < 1 && price > 0){
          return {totalPrice: true};
        }
        const isRangeValid = ((cash + card) <= price);
        return isRangeValid ? null : {totalPrice: true};
      }
    }

    if(paymentType === 5){
      const cash: number = form.get('cash')?.value ? +form.get('cash')?.value : 0;
      const card: number = form.get('card')?.value ? +form.get('card')?.value : 0;
      const balance: number = form.get('balance')?.value ? +form.get('balance')?.value : 0;
      const price: number = form.get('price')?.value ? +form.get('price')?.value : 0;
      if((cash + card + balance) === 0){
        return {totalPrice: true};
      }
      if ((cash || card || balance) && price) {
        if((cash + card + balance) < 1 && price > 0){
          return {totalPrice: true};
        }
        return ((cash + card + balance) <= price) ? null : {totalPrice: true};
      }
    }

    if(paymentType === 7){
      const cash: number = form.get('cash')?.value ? +form.get('cash')?.value : 0;
      const card: number = form.get('card')?.value ? +form.get('card')?.value : 0;
      const consignation: number = form.get('consignation')?.value ? +form.get('consignation')?.value : 0;
      const price: number = form.get('price')?.value ? +form.get('price')?.value : 0;
      if((cash + card + consignation) === 0){
        return {totalPrice: true};
      }
      if ((cash || card || consignation) && price) {
        if((cash + card + consignation) < 1 && price > 0){
          return {totalPrice: true};
        }
        return ((cash + card + consignation) <= price) ? null : {totalPrice: true};
      }
    }

    if(paymentType === 8){
      const bankTransfer: number = form.get('bankTransfer')?.value ? +form.get('bankTransfer')?.value : 0;
      const price: number = form.get('price')?.value ? +form.get('price')?.value : 0;
      if(bankTransfer === 0){
        return {totalPrice: true};
      }
      if (bankTransfer && price) {
        if(bankTransfer < 1 && price > 0){
          return {totalPrice: true};
        }
        return (bankTransfer <= price) ? null : {totalPrice: true};
      }
    }

    // paymentTypes 4, 6, 9, 10, 11 reach here and intentionally skip sum validation.
    // Types 1, 2, 3, 5, 7, 8 are enforced in the explicit branches above.
    return null;
  }
}
